<template>
  <v-container class="payment-container">
    <v-expansion-panel popout light class="futuristic-expansion">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            <h4 class="earth-color">GLOBAL SEARCH</h4>
            <div class="title-decoration"></div>
          </div>
        </template>
        <template v-slot:actions>
          <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
        </template>
        <v-card flat class="futuristic-card">
          <v-card-title class="card-header">
            <div>
              <h6 class="earth-color">KEYWORD SEARCH</h6>
              <div class="title-decoration"></div>
            </div>
          </v-card-title>
          <v-form @submit.prevent="searchTerm()">
            <v-layout row wrap>
              <v-flex lg8 md8 sm12 xs12>
                <v-container>
                  <v-text-field
                    label="Search by: Booking Ref, Client Name, Ticket Number, Organisation Name, Vehicle Registration, School Name, Email, Phone Number"
                    v-model="term.key"
                    required
                    class="futuristic-input"
                  ></v-text-field>
                </v-container>
              </v-flex>
              <v-flex lg4 md4 sm12 xs12>
                <v-container fluid>
                  <v-btn :depressed="true" color="#587e27" type="submit" class="futuristic-btn">
                    <v-icon left>search</v-icon> Search
                  </v-btn>
                  <v-btn :depressed="true" color="#e84118" @click="reset()" class="futuristic-btn">
                    Reset
                  </v-btn>
                </v-container>
              </v-flex>
            </v-layout>
          </v-form>
          <v-divider class="futuristic-divider"></v-divider>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 class="earth-color">Bookings</h4>
          <div class="title-decoration"></div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          class="futuristic-search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="getInspectionToday"
        :search="search"
        :pagination.sync="pagination"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td data-label="Created At">{{ formated_date_time(props.item.created_at) }}</td>
          <td data-label="Booking Ref">
            <router-link :to="{
              name: 'BookingInspection',
              params: { booking_id: props.item.booking_public_id },
            }">
              <a class="futuristic-link">{{ props.item.booking_ref_code }}</a>
            </router-link>
          </td>
          <td data-label="Vehicle Registration">
            <router-link :to="{
              name: 'BookingInspection',
              params: { booking_id: props.item.booking_public_id },
            }">
              <a class="futuristic-link">{{ props.item.vehicle_registration }}</a>
            </router-link>
          </td>
          <td data-label="Entry Pax">{{ props.item.guest_total }}</td>
          <td data-label="Client Name">
            <router-link :to="{
              name: 'BookingInspection',
              params: { booking_id: props.item.booking_public_id },
            }">
              <a class="futuristic-link">{{ props.item.booking_done_by }}</a>
            </router-link>
          </td>
          <td data-label="Check In">{{ formated_date(props.item.booking_check_in_date) }}</td>
          <td data-label="Check In Status" class="bold">{{ props.item.booking_check_in_status }}</td>
          <td data-label="Inspection Status" :style="props.item.booking_color">{{ props.item.inspect_alert_status }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              :items="rowsPerPageItems"
              v-model="pagination.rowsPerPage"
              label="Rows per page"
              class="futuristic-input"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-dialog v-model="unticketed_alert_dialog" persistent max-width="600px">
      <v-btn
        :depressed="true"
        color="#587e27"
        class="futuristic-btn white--text"
        block
        slot="activator"
      >
        ADD UNTICKETED
      </v-btn>
      <v-card flat class="futuristic-card">
        <v-card-title class="card-header">
          <div>
            <h4 class="earth-color">GATE ENTRY DETAILS</h4>
            <div class="title-decoration"></div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  label="Select Entrance"
                  v-model="unticketed_details.unticketed_gate"
                  :items="allGates"
                  item-text="gate_name"
                  item-value="gate_public_id"
                  :rules="[(v) => !!v || 'Entrance is required']"
                  required
                  class="futuristic-input"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  label="Destination*"
                  v-model="unticketed_details.unticketed_destination"
                  :items="allDestinations"
                  item-text="destination_name"
                  item-value="destination_public_id"
                  :loading="$loadingTrue"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Number of Adults"
                  type="number"
                  min="1"
                  step="1"
                  v-model="unticketed_details.unticketed_adults"
                  oninput="this.value = Math.max(1, this.value)"
                  :rules="[
                    v => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 1) || 'Must be a whole number, 1 or greater'
                  ]"
                  required
                  class="futuristic-input"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Number of Children"
                  type="number"
                  min="0"
                  step="1"
                  v-model="unticketed_details.unticketed_children"
                  oninput="this.value = Math.max(0, this.value)"
                  :rules="[
                    v => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater'
                  ]"
                  required
                  class="futuristic-input"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Number of Infants"
                  type="number"
                  min="0"
                  step="1"
                  v-model="unticketed_details.unticketed_infants"
                  oninput="this.value = Math.max(0, this.value)"
                  :rules="[
                    v => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater'
                  ]"
                  required
                  class="futuristic-input"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Number of Tour driver/guide"
                  type="number"
                  min="0"
                  step="1"
                  v-model="unticketed_details.unticketed_guide"
                  oninput="this.value = Math.max(0, this.value)"
                  :rules="[
                    v => (v !== '' && Number.isInteger(Number(v)) && Number(v) >= 0) || 'Enter a whole number 0 or greater'
                  ]"
                  required
                  class="futuristic-input"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-if="isConservancyVehicle"
                  label="Select Vehicle Registration"
                  v-model="unticketed_details.unticketed_vehicle_registration"
                  :items="allAutos"
                  item-text="auto"
                  item-value="public_id"
                  :loading="$loadingTrue"
                  :rules="[(v) => !!v || 'Select a vehicle']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
                <v-text-field
                  v-else
                  label="Enter Vehicle Registration"
                  v-model="unticketed_details.unticketed_vehicle_registration"
                  :rules="[(v) => !!v || 'Vehicle registration is required']"
                  required
                  class="futuristic-input"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 v-if="isConservancyVehicle && unticketed_details.unticketed_vehicle_registration">
                <v-autocomplete
                  label="Select Driver"
                  v-model="unticketed_details.unticketed_driver"
                  :items="allDrivers"
                  item-text="driver"
                  item-value="id"
                  :loading="$loadingTrue"
                  :rules="[(v) => !!v || 'Select a driver']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 v-if="isConservancyVehicle && unticketed_details.unticketed_vehicle_registration">
                <v-text-field
                  label="Enter Mileage"
                  v-model="unticketed_details.unticketed_mileage"
                  type="number"
                  step="0.1"
                  oninput="this.value = Math.max(0, this.value)"
                  :rules="[
                    v => !!v || 'Mileage is required',
                    v => parseFloat(v) >= 0 || 'Mileage must be positive'
                  ]"
                  required
                  class="futuristic-input"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-switch
                  v-model="unticketed_details.convert_to_booking"
                  label="Convert to booking"
                  class="futuristic-input"
                  color="#587e27"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#e84118" flat @click="unticketed_alert_dialog = false" class="futuristic-btn">
            Close
          </v-btn>
          <v-btn
            v-if="unticketed_details.unticketed_destination && unticketed_details.unticketed_adults > 0 && unticketed_details.unticketed_vehicle_registration"
            color="#587e27"
            flat
            @click="postAlert()"
            class="futuristic-btn"
          >
            Add Gate Entry
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn
      :depressed="true"
      color="#587e27"
      @click="getUnticketed()"
      class="futuristic-btn"
    >
      VIEW UNTICKETED ALERTS
    </v-btn>
  </v-container>
</template>

<script>
import SearchTabs from "./FindBooking";
export default {
  components: { SearchTabs },
  name: "BookingsInspection",
  data() {
    return {
      search: "",
      term: {
        key: "",
      },
      columns: [
        {
          text: "Created At",
          value: "created_at",
        },
        {
          text: "Booking Ref",
          value: "booking_ref_code",
        },
        {
          text: "Vehicle Registration",
          value: "vehicle_registration",
        },
        {
          text: "Entry Pax",
          value: "guest_total",
        },
        {
          text: "Client Name",
          value: "booking_done_by",
        },
        {
          text: "Check In",
          value: "booking_check_in_date",
        },
        {
          text: "Check In Status",
          value: "booking_check_in_status",
        },
        {
          text: "Inspection Status",
          value: "inspect_alert_status",
        },
      ],
      pagination: {
        rowsPerPage: 10
      },
      rowsPerPageItems: [10, 25, { text: 'All', value: -1 }],
      unticketed_alert_dialog: false,
      unticketed_details: {
        unticketed_destination: "",
        unticketed_adults: 0,
        unticketed_children: 0,
        unticketed_vehicle_registration: "",
        alert: true,
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
    };
  },
  created() {
    this.$store.dispatch("get_inspection_bookings_today");
    this.$store.dispatch("get_all_destinations");
  },
  methods: {
    openBooking: function (publicId) {
      this.$router.push({
        name: "BookingInspection",
        params: {
          booking_id: publicId,
        },
      });
    },
    searchTerm: function () {
      this.$store.dispatch("search_inspect_booking_by_key", this.term);
    },
    postAlert: function () {
      this.unticketed_alert_dialog = false;
      this.$store.dispatch("post_unticketed_alert", this.unticketed_details);
    },
    getUnticketed: function (publicId) {
      this.$router.push({
        name: "BookingUnticketedAlert",
      });
    },
    reset: function () {
      this.term.key = "";
      this.$store.dispatch("get_inspection_bookings_today");
    },
  },
};
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-expansion {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-expansion:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-table >>> th {
  color: #587e27;
  font-weight: 600;
}

.futuristic-link {
  color: #587e27;
  text-decoration: none;
  transition: color 0.2s ease;
}

.futuristic-link:hover {
  color: #1b5e20;
}

.futuristic-alert {
  border-radius: 8px;
  background: #fff5f5;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-divider {
  border-color: #587e27;
  opacity: 0.3;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }
}
</style>